import { omrehBaseClient } from "./client";
const AddAirLineSLA = (data) => {
  return omrehBaseClient.post('AirLineSLA', {
    'airLine': data.airLine,
    'operation': data.operation,
    'dutiesAndTaxes': data.dutiesAndTaxes,
    'departureCurrency': data.departureCurrency,
    'returnCurrency': data.returnCurrency
  })
}
const GetFlightDelayFormByFlightId = (flightid) => {
  return omrehBaseClient.post('AirLineSLA/GetFlightDelayFormByFlightId',
    '', {
    params: {
      'Id': flightid
    }
  }
  );
}
const FilterAirLineSLA=(filterData)=>{
  return omrehBaseClient.post('AirLineSLA/FilterAirLineSLA',
  // '{\n  "airLineType": 1,\n  "operation": 1,\n  "paginationParam": {\n    "orderBy": "CreateDate",\n    "orderDescending": true,\n    "pageNumber": 1,\n    "pageSize": 10\n  }\n}',
  {
    'airLineType': filterData.airLineType,
    'operation': filterData.operation,
    'paginationParam': {
      'orderBy': 'CreateDate',
      'orderDescending': filterData.orderDescending,
      'pageNumber': filterData.pageNumber,
      'pageSize': filterData.pageSize
    }
  }
  );
}

const UpdateAirLineSLA=(id,data)=>{
  return omrehBaseClient.put('AirLineSLA',
  // '{\n  "airLine": 1,\n  "operation": 0,\n  "dutiesAndTaxes": 0,\n  "departureCurrency": 1,\n  "returnCurrency": 1,\n  "isActive": true\n}',
  {
    'airLine':data.airLine,
    'operation': data.operation,
    'dutiesAndTaxes': data.dutiesAndTaxes,
    'departureCurrency': data.departureCurrency,
    'returnCurrency': data.returnCurrency,
    'isActive': true
  },
  {
    params: {
      'id': id
    }
});
}
const deleteAirLineSLA=(id)=>{
return omrehBaseClient.delete('AirLineSLA',{
  params: {
      'Id': id
    } 
})
}
const AddAirLinePenaltyRate=(airLineSLAId,data)=>{
return omrehBaseClient.post('AirLinePenaltyRate', {
    'fromHour': data.fromHour,
    'toHour': data.toHour,
    'penaltyPercent': data.penaltyPercent,
    'airLineSLAId': airLineSLAId
  })
}

const deleteAirLinePenaltyRate=(id)=>{
return omrehBaseClient.delete('AirLinePenaltyRate',{
  params: {
      'Id': id
    } 
})
}
const UpdateAirLinePenaltyRate=(id,data)=>{
  return omrehBaseClient.put('AirLinePenaltyRate',
  // '{\n  "airLine": 1,\n  "operation": 0,\n  "dutiesAndTaxes": 0,\n  "departureCurrency": 1,\n  "returnCurrency": 1,\n  "isActive": true\n}',
  {
    'fromHour': data.fromHour,
    'toHour': data.toHour,
    'penaltyPercent': data.penaltyPercent,
    'isActive': true
  },
  {
    params: {
      'id': id
    }
});
}

const AddAirLineAgeGroupRate=(airLineSLAId,data)=>{
return omrehBaseClient.post('AirLineAgeGroupRate', {
    'airLineSLAId': airLineSLAId,
    'ageType': data.ageType,
    'ticketPrice': data.ticketPrice,
  })
}

const deleteAirLineAgeGroupRate=(id)=>{
return omrehBaseClient.delete('AirLineAgeGroupRate',{
  params: {
      'Id': id
    } 
})
}
const UpdateAirLineAgeGroupRate=(id,data)=>{
  return omrehBaseClient.put('AirLineAgeGroupRate',
  // '{\n  "airLine": 1,\n  "operation": 0,\n  "dutiesAndTaxes": 0,\n  "departureCurrency": 1,\n  "returnCurrency": 1,\n  "isActive": true\n}',
  {
    'ageType': data.ageType,
    'ticketPrice': data.ticketPrice,
    'isActive': true
  },
  {
    params: {
      'Id': id
    }
});
}
const CalculatePilgrimFlightDelayCompensation=(flightId)=>{
  return omrehBaseClient.post('AirLineSLA/CalculatePilgrimFlightDelayCompensation',
  '',{
    params: {
      'flightId': flightId
    }
  }
  );

}
/////////////////////////////


const GetFlightCompAccomodationByFlightId=(id)=>{
return omrehBaseClient.get('FlightCompensationAccommodation/GetAllByFlightId',{
  params: {
      'flightId': id
    } 
})
}
const AddFlightCompAccomodation=(flightId,data)=>{
return omrehBaseClient.post('FlightCompensationAccommodation', {
    "flightsId": flightId,
    "hotelName": data.hotelName,
  "numberOfRooms": data.numberOfRooms,
  "roomRate": data.roomRate,
  "lengthOfStay":data.lengthOfStay,
  "brokerId": data.brokerId,
  "passengerId": data.passengerId,
  "brokerGroupNo":data.brokerGroupNo
  })
}

const deleteFlightCompAccomodation=(id)=>{
return omrehBaseClient.delete('FlightCompensationAccommodation',{
  params: {
      'Id': id
    } 
})
}
const UpdateFlightCompAccomodation=(id,data)=>{
  return omrehBaseClient.put('FlightCompensationAccommodation',
  // '{\n  "airLine": 1,\n  "operation": 0,\n  "dutiesAndTaxes": 0,\n  "departureCurrency": 1,\n  "returnCurrency": 1,\n  "isActive": true\n}',
  {
    "hotelName": data.hotelName,
  "numberOfRooms": data.numberOfRooms,
  "roomRate": data.roomRate,
  "lengthOfStay":data.lengthOfStay,
    "isActive": true,
  },
  {
    params: {
      'Id': id
    }
});
}
//////////////////////////////

const GetFlightCompNutritionByFlightId=(id)=>{
return omrehBaseClient.get('FlightCompensationNutrition/GetAllByFlightId',{
  params: {
      'flightId': id
    } 
})
}
const AddFlightCompNutrition=(flightId,data)=>{
return omrehBaseClient.post('FlightCompensationNutrition', {
    "flightsID": flightId,
    "brokerId": data.brokerId,
  "passengerId": data.passengerId,
  "brokerGroupNo":data.brokerGroupNo,
 "fcMealsList":data.fcMealsList
  })
}

const deleteFlightCompNutrition=(id)=>{
return omrehBaseClient.delete('FlightCompensationNutrition',{
  params: {
      'Id': id
    } 
})
}
const AddMeal=(nutritionServicesID,data)=>{
return omrehBaseClient.post('FCMeals', {
    "nutritionServicesID": nutritionServicesID,
   "mealType": data.mealType,
  "mealRate": data.mealRate,
   "description":data.description 
  })
}
const deleteMeal=(id)=>{
  return omrehBaseClient.delete('FCMeals',{
  params: {
      'Id': id
    } 
})
}
const UpdateMeal=(id,data)=>{
   return omrehBaseClient.put('FCMeals',
  // '{\n  "airLine": 1,\n  "operation": 0,\n  "dutiesAndTaxes": 0,\n  "departureCurrency": 1,\n  "returnCurrency": 1,\n  "isActive": true\n}',
  {
    "mealRate": data.mealRate,
  "description": data.description,
    "isActive": true
  },
  {
    params: {
      'Id': id
    }
});
}
//////////////
const GetFlightCompTransportByFlightId=(id)=>{
return omrehBaseClient.get('FlightCompensationTransport/GetAllByFlightId',{
  params: {
      'flightId': id
    } 
})
}
const AddFlightCompTransport=(flightId,data)=>{
return omrehBaseClient.post('FlightCompensationTransport', {
    'flightsID': flightId,
   "brokerId": data.brokerId,
  "passengerId": data.passengerId,
  "brokerGroupNo":data.brokerGroupNo,
   "fcTransferList":data.fcTransferList 
  })
}

const deleteFlightCompTransport=(id)=>{
return omrehBaseClient.delete('FlightCompensationTransport',{
  params: {
      'Id': id
    } 
})
}

const AddTransport=(transferServicesIDId,data)=>{
return omrehBaseClient.post('FCTransport', {
    'transferServicesID': transferServicesIDId,
   "passengerCount": data.passengerCount,
  "vehicleType": data.vehicleType,
  "transferRate":data.transferRate,
   "description":data.description 
  })
}
const deleteTransport=(id)=>{
  return omrehBaseClient.delete('FCTransport',{
  params: {
      'Id': id
    } 
})
}
const UpdateTransport=(id,data)=>{
   return omrehBaseClient.put('FCTransport',
  // '{\n  "airLine": 1,\n  "operation": 0,\n  "dutiesAndTaxes": 0,\n  "departureCurrency": 1,\n  "returnCurrency": 1,\n  "isActive": true\n}',
  {
    "passengerCount": data.passengerCount,
  "transferRate":data.transferRate,
   "description":data.description,
   "isActive": true
  },
  {
    params: {
      'Id': id
    }
});
}
const calculateFlightCompensation=(flightId)=>{
return omrehBaseClient.post('AirLineSLA/CalculatePilgrimFlightDelayCompensation','',{
  params:{
    'flightId':flightId
  }
})
}


const FlightCompensationApi = {
  GetFlightDelayFormByFlightId, AddAirLineSLA, FilterAirLineSLA,UpdateAirLineSLA,deleteAirLineSLA,
  AddAirLinePenaltyRate,AddAirLineAgeGroupRate,UpdateAirLinePenaltyRate,UpdateAirLineAgeGroupRate,
  deleteAirLinePenaltyRate,deleteAirLineAgeGroupRate,CalculatePilgrimFlightDelayCompensation,
  GetFlightCompAccomodationByFlightId,AddFlightCompAccomodation,deleteFlightCompAccomodation,UpdateFlightCompAccomodation,
   GetFlightCompNutritionByFlightId,AddFlightCompNutrition,deleteFlightCompNutrition,AddMeal,deleteMeal,UpdateMeal,
   GetFlightCompTransportByFlightId,AddFlightCompTransport,deleteFlightCompTransport,AddTransport,deleteTransport,UpdateTransport,
   calculateFlightCompensation
}
export default FlightCompensationApi;
